import { DISABLE_PRODUCT_REVIEW_NEW } from "../config/constants";
import MappingDataReviewNew from "../screens/mapping_tool/mappingReview/MappingDataReview.new";
import MappingDataReview from "../screens/mapping_tool/mappingReview/MappingDataReview";
import MappingTool from "../screens/mapping_tool/MappingTool";
import SimulateDrawingTool from "../screens/simulate_drawing_tool/SimulateDrawingTool";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

export const MappingRoutes = [
  {
    path: ":mappingType",
    route: <MappingTool />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  },
  {
    path: "simulate-mapping/:productId/:salesUnitId",
    route: <SimulateDrawingTool />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  },
  {
    path: "review/:mappingType/:drawingId/:ownerId/:sourceId",
    route: DISABLE_PRODUCT_REVIEW_NEW ? <MappingDataReview /> : <MappingDataReviewNew />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess]
  }
];
